import { FC } from 'react';

export const Wordmark: FC<any> = () => null;
